/**
 * SiteUp (W4): transforma o `content_attributes.poll` que o backend agrega em
 * linhas prontas para desenhar.
 *
 * Vive fora do componente porque é a única parte com regra de verdade — e é o
 * que precisa de teste real, não de inspeção do arquivo .vue.
 *
 * O backend guarda a escolha ATUAL de cada votante (`votes[telefone] = [...]`),
 * nunca um contador: no WhatsApp o voto é trocável e removível, então a
 * contagem tem que ser sempre derivada.
 *
 * @param {{options?: string[], votes?: Record<string, string[]>}} poll
 * @returns {{option: string, count: number, percentage: number, leading: boolean}[]}
 */
export function buildPollResults(poll = {}) {
  const options = Array.isArray(poll?.options) ? poll.options : [];
  const votes = Object.values(poll?.votes ?? {});

  const counts = options.map(option => ({
    option,
    count: votes.filter(selected => (selected ?? []).includes(option)).length,
  }));

  const highest = Math.max(...counts.map(item => item.count), 0);

  return counts.map(item => ({
    ...item,
    // A barra é proporcional à opção mais votada, e não ao total de votantes:
    // com voto múltiplo a soma passa de 100% e todas as barras ficariam
    // achatadas contra o limite.
    percentage: highest > 0 ? Math.round((item.count / highest) * 100) : 0,
    leading: highest > 0 && item.count === highest,
  }));
}

/**
 * Quantas pessoas votaram — uma por votante, mesmo com voto múltiplo. É o
 * número que diz o alcance da enquete, e o mesmo que o WhatsApp mostra.
 *
 * @param {{votes?: Record<string, string[]>}} poll
 * @returns {number}
 */
export function countVoters(poll = {}) {
  return Object.keys(poll?.votes ?? {}).length;
}
